<template>
  <div class="card_lottery">
    <div v-for="(group,index) in cards_grouped" :key="'g_'+ index" class="cards_row">
      <div v-for="(item,index2) in group" :key="'item_' + item.id" :class="{'card':true,'has_award':item.award}">
        <div :style="card_styles[item.id]" class="card_back" @click="lottery(item)">
          <!--最后一个-->
          <div v-if="item.is_last">
            <img class="lock" v-if="is_last_locked" :src="lock_img"/>
            <img class="button" v-else :src="lot_btn_on"/>
          </div>
          <div v-else>
            <!--如果有抽奖机会 或者 未登录状态显示-->
            <img :src="lot_btn_on" v-if="changce > 0 || !is_login" class="button"/>
            <img :src="lot_btn_off" v-else class="button"/>
          </div>
        </div>
        <div :style="awards_styles[item.id]" class="card_front" @click="process_award(item.award)">

        </div>
      </div>

    </div>
  </div>
</template>
<script>

  /**
   * 卡片抽奖
   *
   ext: {
lot_btn_off: "https://vipcdn.mgtv.com/upload/20180928/v/btn_dark.png", //无抽奖机会按钮
lot_btn_on: "https://vipcdn.mgtv.com/upload/20180928/v/button2.png", //有抽奖机会按钮
lot_lock: "https://vipcdn.mgtv.com/upload/20180928/v/lock.png",//锁
lot_card0: "https://vipcdn.mgtv.com/upload/20180928/v/1.png",//卡牌
lot_card1: "https://vipcdn.mgtv.com/upload/20180928/v/2.png",//卡牌
lot_card2: "https://vipcdn.mgtv.com/upload/20180928/v/3.png",//卡牌
lot_card3: "https://vipcdn.mgtv.com/upload/20180928/v/4.png",//卡牌
lot_card4: "https://vipcdn.mgtv.com/upload/20180928/v/5.png",//卡牌
lot_card5: "https://vipcdn.mgtv.com/upload/20180928/v/6.png",//卡牌
lot_card6: "https://vipcdn.mgtv.com/upload/20180928/v/7.png",//卡牌
lot_card7: "https://vipcdn.mgtv.com/upload/20180928/v/8.png",//卡牌
lot_card8: "https://vipcdn.mgtv.com/upload/20180928/v/last.png",//卡牌
lot_cardnum: "9",//卡牌数量
}
   */
  import Vue from 'vue'
  import click_handler from '../../../tools/mgtv/click'
  import {click_event, error_event} from '../../../tools/mgtv/analysis'

  import to_casher from '../../../tools/mgtv/casher'
  import {openLink} from '../../../tools/mgtv/link'
  import download from '../../../tools/mgtv/downapp'
  import {getJSON} from '../../../api/myaxios'
  import process_award from './process_award'
  import {process_error_action} from '../../../tools/mgtv/error_action'
  import preload from '../../../tools/preload'
  import chunk from 'lodash/chunk'
  import {GET_LOTTERY_HISTORY} from '../../../constant/eventbus'

  function cardPosToId(card_pos) {
    const regexMatch = /lot_card(\d+)/.exec(card_pos);
    if (regexMatch && regexMatch.length === 2) {
      return parseInt(regexMatch[1]);
    }
    return null
  }

  export default {
    name: "CardLottery",
    props: {
      info: {
        type: Object
      }
    },
    data() {
      return {
        remain_times: 0
      }
    },
    created() {
      //预取奖品
      // this.fetchPrizes();
      // window.$bus.$emit(GET_LOTTERY_HISTORY)

    },
    mounted() {
      // setTimeout(() => {
      //   for (let i = 0; i < 9; i++) {
      //     setTimeout(() => {
      //       console.log(i, this.awards)
      //       this.awards.splice(i, 1, "https://vipcdn.mgtv.com/upload/20180928/a/1.png")
      //     }, i * 500);
      //   }
      // }, 1000)
    },
    computed: {
      act_name: function () {
        return window.rootdata.act_name
      },
      changce: function () {
        return window.$bus.lottery.remain_chance
      },
      card_styles: function () {
        return this.cards.map(item => {
          if (!item) {
            return ""
          }
          return {
            background: `url(${item.img}) 0% 0% / cover no-repeat`,
          }
        })
      },
      awards_styles: function () {
        return this.cards.map(item => {
          if (!item.award) {
            return ""
          }
          return {
            background: `url(${item.award.icon}) 0% 0% / cover no-repeat`,
          }
        })
      },
      is_last_locked: function () {
        const cardsHasAwards = this.cards.filter(item => {
          return item.award != null;
        });
        if (cardsHasAwards.length >= this.cards.length - 1) {
          return false
        }
        return true

      },
      is_login: function () {
        return window.$bus.user.uuid !== null
      },
      cards: function () {
        const ext = window.$bus.act.ext;
        const cardNum = parseInt(ext.lot_cardnum);
        const cards = []
        for (let i = 0; i < cardNum; i++) {
          const key = 'lot_card' + i;
          cards.push({
            id: i, //id,在cards里面的位置,只做标识
            img: ext[key], //卡面图片
            card_pos: key, //卡片位置
            is_last: i === cardNum - 1, //是否是最后一个
            award: null //奖品
          })
        }
        console.log('cards', cards);
        window.$bus.lottery.lottery_history.forEach(item => {
          const id = cardPosToId(item.card_pos);
          if (id !== null) {
            cards[id] && (cards[id].award = item);
          }
        });
        return cards
      },
      cards_grouped: function () {
        const res = chunk(this.cards, 3);
        console.log('cards_grouped', res);
        return res;
      },
      lot_btn_on: function () { //图片
        return window.$bus.act.ext.lot_btn_on || this.info.cardLottery.lot_btn_on || "https://vipcdn.mgtv.com/upload/20180928/v/button2.png"
      },
      lot_btn_off: function () { //图片
        return window.$bus.act.ext.lot_btn_off || this.info.cardLottery.lot_btn_off || "https://vipcdn.mgtv.com/upload/20180928/v/btn_dark.png"
      },
      lock_img: function () { //锁图片
        return window.$bus.act.ext.lot_lock || this.info.cardLottery.lot_lock || "https://vipcdn.mgtv.com/upload/20180928/v/lock.png"
      }


    },
    methods: {
      lottery_from_remote(card_pos) {
        window.$toast.loading({
          mask: false,
          forbidClick: true, // 禁用背景点击
          message: '正在抽奖',
          duration: 10000
        });
        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/checkandlot", {
          act_name: this.act_name,
          ticket: window.$bus.user.ticket,
          card_pos
        }).then(res => {
          window.$toast.clear()
          if (!res) {
            window.$toast('请求超时，请重试');
            return;
          }
          if (res && res.ret === 0) {
            const id = cardPosToId(res.data.card_pos);
            //异常情况，没有id
            if (id === null) {
              process_award(res.data)
              return;
            }
            // const cardInfo = Object.assign({}, this.cards[id]);
            // cardInfo.award = res.data;
            // console.log(cardInfo)
            // Vue.set(this.cards, `${id}.award`, res.data);
            Vue.set(window.$bus.lottery, 'remain_chance', res.data.remain_chance);
            window.$bus.lottery.lottery_history.push(res.data);
            setTimeout(() => {
              process_award(res.data)
            }, 1000);

          } else {
            process_error_action(res.data.action, res.msg);
            setTimeout(() => {
              click_event('抽奖失败_' + res.msg)
            }, 0)
          }
        }).catch(e => {
          window.$toast.clear()
          window.$toast('抽奖失败,请重试')
          click_event('抽奖异常')
          error_event(e)
        })
      },
      lottery(item) {
        click_handler(this.info.name + '-抽奖按钮', () => {
          if (item.is_last && this.is_last_locked) {
            return;
          }
          this.lottery_from_remote(item.card_pos);
        }, {
          need_login: true,
          need_vip: false,
          need_act: true
        });
      },
      process_award: process_award
    },
  }
</script>
<style lang="stylus">
  @import "../../../share/mixins.styl"

  .card_lottery
    width 7.5rem
    position relative
    .cards_row
      width 100%
      position relative
      display flex
      flex-direction row
    .card
      width 2.5rem
      height 3.58rem
      position relative
    .card_back //卡背，IP
      position absolute
      width 2.5rem
      height 3.58rem
      transition: all 1s
      backface-visibility: hidden
      top 0
      left 0
    .card_front //卡面，奖品
      position absolute
      width 2.5rem
      height 3.58rem
      transition: all 1s
      backface-visibility: hidden
      transform: rotateY(-180deg)
      top 0
      left 0

    .has_award
      .card_back
        transform: rotateY(180deg) !important
      .card_front
        transform: rotateY(0deg) !important

    .lock
      position absolute
      width .56rem
      height .74rem
      center()

    .button
      position absolute
      width 1.63rem
      height .7rem
      bottom .6rem
      hcenter()


</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/Lottery/CardLottery.vue